var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPr1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 235,
    viewBox: "0 0 684 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.309 193.286H440.419V194.123H213.713L199.069 212.544H1.6748V211.706H198.665L213.309 193.286Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53568 211.706C7.53568 213.787 5.84876 215.474 3.76784 215.474C1.68692 215.474 0 213.787 0 211.706C0 209.625 1.68692 207.938 3.76784 207.938C5.84876 207.938 7.53568 209.625 7.53568 211.706Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_439_43)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_439_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503 131V104H580V131H503Z",
    stroke: "#61FF00",
    strokeOpacity: 0.32,
    strokeWidth: 70
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M468.5 87.9699L483.953 69.5H614.5V150.467L595.706 165.5H468.5V87.9699Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M440 194L468 165",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_439_43",
    x: 399,
    y: 0,
    width: 285,
    height: 235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5,
    result: "effect1_foregroundBlur_439_43"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_439_43",
    x: 420,
    y: 21,
    width: 243,
    height: 193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "effect1_foregroundBlur_439_43"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr1);
export default __webpack_public_path__ + "static/media/pr1.c53d0480bfc56c430527e6d9d6da396c.svg";
export { ForwardRef as ReactComponent };